import { render, staticRenderFns } from "./KitBudgetTabV2.vue?vue&type=template&id=4beb2a4f&scoped=true&"
import script from "./KitBudgetTabV2.vue?vue&type=script&lang=js&"
export * from "./KitBudgetTabV2.vue?vue&type=script&lang=js&"
import style0 from "./KitBudgetTabV2.vue?vue&type=style&index=0&id=4beb2a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb2a4f",
  null
  
)

export default component.exports